// WebSocketProvider.js
import React, { createContext, ReactNode, useEffect, useRef } from "react";
import WebSocketStore from "./WebSocket";
import { useAuth } from "../Auth/auth.provider";

interface WebSocketProviderProps {
  children: ReactNode;
}

export const WebSocketContext = createContext<WebSocketStore | null>(null);
WebSocketContext.displayName = "WebSocketContext";

export const WebSocketProvider = ({ children }: WebSocketProviderProps) => {
  const authStore = useAuth();
  const storeRef = useRef<WebSocketStore | null>(null);
  if (!storeRef.current) {
    storeRef.current = new WebSocketStore(authStore);
  }
  const store = storeRef.current;

  useEffect(() => {
    store.initializeWebSocket(); // Call the initialization method only once when component mounts
  }, []); // Empty dependency array ensures this effect runs only once

  return <WebSocketContext.Provider value={store}>{children}</WebSocketContext.Provider>;
};
